import React, { useState } from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';
import Guides from 'athena/components/mentoring-program/guides';
import { gray1, gray2, gray6 } from 'styles/global_defaults/colors';
import { halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { semiBoldFontWeight, textMediumFontSize } from 'styles/global_defaults/fonts';

type SubTab = 'guides' | 'action-items';

type GuidanceTabProps = {
  onScroll: React.ComponentProps<'div'>['onScroll'];
  scrollEnabled: boolean;
};

const subTabsStyles = css`
  gap: ${halfSpacing}px;
  height: 45px;
`;

const chipBaseStyles = css`
  padding: 0 ${standardSpacing}px;
  height: 35px;
  border-radius: 30px;
  font-size: ${textMediumFontSize}px;
  font-weight: ${semiBoldFontWeight};
  cursor: pointer;
`;

const selectedChipStyles = css`
  ${chipBaseStyles};
  background-color: transparent;
  color: ${gray1};
  border: 1px solid ${gray1};
`;

const unselectedChipStyles = css`
  ${chipBaseStyles};
  background-color: ${gray6};
  color: ${gray2};
  border: 1px solid transparent;
`;

const GuidanceTab = ({ onScroll, scrollEnabled }: GuidanceTabProps) => {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('guides');
  const translationBase = t.MENTORING_PROGRAMS.GUIDANCE.SUB_TABS;

  const subTabs: { id: SubTab; label: string }[] = [
    { id: 'guides', label: translationBase.GUIDES() },
    { id: 'action-items', label: translationBase.ACTION_ITEMS() },
  ];

  const renderChips = () => (
    <div css={subTabsStyles} className='d-flex align-items-center'>
      {subTabs.map(({ id, label }) => (
        <button
          key={id}
          type='button'
          className='d-flex align-items-center'
          css={activeSubTab === id ? selectedChipStyles : unselectedChipStyles}
          aria-pressed={activeSubTab === id}
          onClick={() => setActiveSubTab(id)}
        >
          {label}
        </button>
      ))}
    </div>
  );

  return (
    <div className='d-flex flex-column h-100'>
      {activeSubTab === 'guides' && (
        <Guides onScroll={onScroll} scrollEnabled={scrollEnabled}>
          {renderChips()}
        </Guides>
      )}
      {activeSubTab === 'action-items' && (
        // TODO: add the pre-assigned action items UI
        <div className='mb-4'>{renderChips()}</div>
      )}
    </div>
  );
};

export default GuidanceTab;
